import { Route, Routes } from 'react-router-dom';
import { ProvideAuth } from './components/auth/use-auth';
import LoginAuth from './components/auth/LoginAuth';
import Logout from './components/auth/Logout';
import CreateNewAccount from './components/auth/CreateNewAccount';
import ThankYou from './components/auth/ThankYou';
import Bootstrap from './components/bootstrap/Bootstrap';
import ResetPassword from './components/auth/ResetPassword';
import NewPassword from './components/auth/NewPassword';
import AuthorizeWithOidcToken from './components/auth/AuthorizeWithOidcToken';
import { useConfig } from './components/bootstrap/ConfigProvider';
import { RequireAuth, RequireNoAuth } from './components/auth/RequireAuth';

export default function Router() {
    const { isOidcEnabled, oidc } = useConfig();

    return (
        <ProvideAuth>
            <Routes>
                <Route
                    path='/CreateNewAccount'
                    element={
                        <RequireNoAuth>
                            <CreateNewAccount />
                        </RequireNoAuth>
                    }
                />

                <Route
                    path='/ResetPassword'
                    element={
                        <RequireNoAuth>
                            <ResetPassword />
                        </RequireNoAuth>
                    }
                />

                <Route
                    path='/NewPassword'
                    element={
                        <RequireNoAuth>
                            <NewPassword />
                        </RequireNoAuth>
                    }
                />

                <Route
                    path='/ThankYou'
                    element={
                        <RequireNoAuth>
                            <ThankYou />
                        </RequireNoAuth>
                    }
                />

                <Route
                    path='/login'
                    element={
                        <RequireNoAuth>
                            <LoginAuth />
                        </RequireNoAuth>
                    }
                />

                <Route path='/logout' Component={Logout} />

                {isOidcEnabled && (
                    <Route
                        path={oidc.redirectUri || '/signin-oidc'}
                        Component={AuthorizeWithOidcToken}
                    />
                )}

                <Route
                    path='/*'
                    element={
                        <RequireAuth>
                            <Bootstrap />
                        </RequireAuth>
                    }
                />
            </Routes>
        </ProvideAuth>
    );
}
